import {
	AssignmentRounded,
	PhotoLibraryRounded,
	TrendingUpRounded,
} from "@mui/icons-material";
import { Grid, Slide, styled, Typography } from "@mui/material";
import growthPerson from "assets/icons/growth.svg";
import { StyledButton } from "components/StyledButton";
import { UnauthenticatedLayout } from "components/UnauthenticatedLayout";
import { Link } from "react-router-dom";
import { routes } from "routes";
import { useKeycloak } from "@react-keycloak/web";

const PREFIX = "LandingPage";

const classes = {
	LeftText: `${PREFIX}-LeftText`,
	Btn: `${PREFIX}-Btn`,
	img: `${PREFIX}-img`,
	iconBox: `${PREFIX}-iconBox`,
	page: `${PREFIX}-page`,
	topGrid: `${PREFIX}-topGrid`,
};

const StyledUnauthenticatedLayout = styled(UnauthenticatedLayout)(
	({ theme }) => ({
		[`& .${classes.LeftText}`]: {
			textAlign: "left",
		},

		[`& .${classes.Btn}.MuiButton-containedPrimary`]: {
			padding: "10px 30px",
			backgroundColor: "#1E3A8A",
			color: "#FFFFFF",
			fontWeight: 700,
			borderRadius: "999px",
			boxShadow: "0 6px 18px rgba(30, 58, 138, 0.35)",
			float: "left",
			margin: "0 20px 0 0",
			"&:hover": {
				backgroundColor: "#2447A5",
				boxShadow: "0 8px 22px rgba(30, 58, 138, 0.45)",
			},
		},

		[`& .${classes.img}`]: {
			maxWidth: "42vw",
		},

		[`& .${classes.iconBox}`]: {
			width: "min-content",
			padding: theme.spacing(2),
		},

		[`& .${classes.page}`]: {
			padding: theme.spacing(10),
			paddingTop: 0,
		},

		[`& .${classes.topGrid}`]: {
			marginBottom: theme.spacing(5),
		},
	}),
);

interface Text {
	title: string;
	description: string;
	icon: JSX.Element;
}
const text: Text[] = [
	{
		title: "Browse expert curated content",
		description:
			"Our STEM content has been created through collaboration with the leading education and STEM experts.",
		icon: <PhotoLibraryRounded fontSize="large" color="primary" />,
	},
	{
		title: "Create assignments for your students ",
		description:
			"Build customisable assignments using our fun and engaging STEM content library.",
		icon: <AssignmentRounded fontSize="large" color="primary" />,
	},
	{
		title: "Real time tracking of student progress",
		description:
			"Monitor how your students are progressing with assignments, with the ability to export results for assessments.",
		icon: <TrendingUpRounded fontSize="large" color="primary" />,
	},
];

export const LandingPage = (): JSX.Element => {
	const { keycloak } = useKeycloak();

	return (
		<StyledUnauthenticatedLayout>
			<div className={classes.page}>
				<Grid
					container
					spacing={10}
					alignItems="center"
					className={classes.topGrid}
				>
					<Grid item xs={6}>
						<Grid container direction="column" spacing={2}>
							<Slide
								direction="right"
								in
								timeout={{ appear: 100, enter: 1000 }}
							>
								<Grid item xs={12}>
									<Typography variant="h1" className={classes.LeftText}>
										Welcome to Science Island. A new way to teach STEM.{" "}
									</Typography>
									<Typography variant="h4" className={classes.LeftText}>
										Researched, peer-reviewed, educational games to promote STEM
									</Typography>
								</Grid>
							</Slide>
							<Grid item xs={12}>
								<StyledButton
									component={Link}
									to={routes._.register.path}
									color="primary"
									variant="contained"
									className={classes.Btn}
								>
									Register
								</StyledButton>
								<StyledButton
									onClick={() => {
										void keycloak.login();
									}}
									color="primary"
									variant="contained"
									className={classes.Btn}
								>
									Sign In
								</StyledButton>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={6}>
						<img
							className={classes.img}
							src={growthPerson}
							alt="Science Island Character"
						/>
					</Grid>
				</Grid>
				<br />
				<Slide direction="up" in timeout={{ appear: 3000, enter: 1000 }}>
					<Grid container justifyContent="space-between" spacing={2}>
						{text.map((item) => (
							<Grid item xs={4} key={item.title}>
								<Grid
									container
									alignContent="flex-start"
									alignItems="flex-start"
									direction="column"
								>
									{item.icon}
									<Typography variant="h5" className={classes.LeftText}>
										{item.title}
									</Typography>
									<Typography variant="subtitle1" className={classes.LeftText}>
										{item.description}
									</Typography>
								</Grid>
							</Grid>
						))}
					</Grid>
				</Slide>
			</div>
		</StyledUnauthenticatedLayout>
	);
};
